export interface IVisualTestState {
  componentPath: [string];
}

export const VisualTestState: IVisualTestState = {
  componentPath: [
    './Breadcrumb/BreadcrumbPage.visualtest',
    './Button/ButtonPage.visualtest',
    './Checkbox/CheckboxPage.visualtest',
    './ChoiceGroup/ChoiceGroupPage.visualtest',
    './ComboBox/ComboBoxPage.visualtest',
    './CommandBar/CommandBarPage.visualtest',
    './ContextualMenu/ContextualMenuPage.visualtest',
    './DetailsList/DetailsListPage.visualtest',
    './Label/LabelPage.visualtest',
    './DocumentCard/DocumentCardPage.visualtest',
    './Dialog/DialogPage.visualtest',
    './Facepile/FacepilePage.visualtest',
    './Toggle/TogglePage.visualtest',
    './Tooltip/TooltipPage.visualtest'
  ]
};